export const Colors = {
  white: "white",
  black: "black",
  darker: "black",
  lighter: "white",
  error: "red",
  warning: "yellow",
  success: "green",
  primary: "black",
  gray: "#F2F2F2",
  blue: "#61A1D6",
  yellow: "#EDCC51", //stars
  primaryColors: {
    green: "#6C8E7D",
    navy: "#324762",
    redOrange: "#B24A31",
    mustard: "#BB8104",
    yellow: "#D7C79D",
    cream: "#C2BCAC",
  },
  rgbPrimaryColors: {
    navy: (percent) => `rgba(50, 71, 98, ${percent})`,
  },
};
